const MANIFESTO_IMG =
  "https://customer-assets.emergentagent.com/job_gen-x-move/artifacts/oit9jz7l_D8F7ACE4-24CA-4D22-A038-E090ABB03E59.png";

const PILLARS = [
  {
    n: "01",
    title: "Modelagem inteligente",
    desc: "Cortes desenhados para o corpo real da mulher ativa. Sustenta, alonga, valoriza.",
  },
  {
    n: "02",
    title: "Tecido premium",
    desc: "Compressão moderada, proteção UV50+, zero transparência. Toque seda, performance esporte.",
  },
  {
    n: "03",
    title: "Do treino à vida",
    desc: "Peças que funcionam da academia ao café — sem trocar de roupa, sem ajustar nada.",
  },
  {
    n: "04",
    title: "Comunidade",
    desc: "Fazer parte da Kora Club é pertencer a mulheres que escolheram o movimento.",
  },
];

export const Manifesto = () => {
  return (
    <section
      id="manifesto"
      data-testid="section-manifesto"
      className="relative bg-kora-forest-deep pt-8 pb-20 md:pt-12 md:pb-32 overflow-hidden"
    >
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20 items-start">
          {/* Left: image with label above */}
          <div className="lg:col-span-5 reveal">
            <p className="font-mono-label text-kora-gold-light mb-4">
              ✦ A Kora Club
            </p>
            <div className="product-frame aspect-[4/5] border border-kora-gold/15 relative">
              <img
                src={MANIFESTO_IMG}
                alt="Nos bastidores da Kora Club"
                data-testid="manifesto-image"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: copy + pillars */}
          <div className="lg:col-span-7">
            <h2
              data-testid="manifesto-headline"
              className="reveal font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.02] tracking-tight text-kora-cream"
            >
              Nenhuma marca brasileira de roupa fitness foi feita para você.{" "}
              <span className="italic text-gold-gradient">Nós fomos.</span>
            </h2>

            <p
              data-testid="manifesto-body"
              className="reveal reveal-delay-1 mt-8 max-w-xl text-base md:text-lg leading-relaxed text-kora-cream/80"
            >
              Você lidera, treina, viaja, decide. Você está no auge. Kora Club
              nasceu para vestir esse momento, sem condescendência, sem
              clichê.
            </p>

            <div className="kora-hr mt-10 mb-10" />

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8 sm:gap-y-10">
              {PILLARS.map((p, i) => (
                <li
                  key={p.n}
                  data-testid={`pillar-${p.n}`}
                  className={`reveal reveal-delay-${(i % 4) + 1} pl-4 border-l border-kora-gold/20 sm:pl-0 sm:border-l-0`}
                >
                  <p className="font-display text-3xl md:text-4xl text-kora-gold-light/90 leading-none mb-2">
                    {p.n}
                  </p>
                  <h3 className="font-display text-xl md:text-2xl text-kora-cream mb-1.5">
                    {p.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-kora-cream/75 max-w-sm">
                    {p.desc}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
